import React from "react";

export const DateInputComponent = ({
  value,
  changeValue,
  name,
  id,
  required = false,
}) => {
  return (
    <div className="bg-white px-10 sm:px-20 py-5 sm:py-10 rounded-xl border-l-4 border-[#5d5df1] mb-3">
      <label htmlFor={id} className="font-medium">
        {name}
      </label>
      {required ? <label className="text-[red] pl-1">*</label> : <></>}
      <br />
      <div className="mt-4">
        <input
          className="txtDate outline-none border p-2 rounded border-gray-500 w-4/5 sm:w-3/5 transition-all duration-300 focus:border-[#1976D2] focus:border-b-2"
          required={required}
          type="date"
          id={id}
          onChange={(e) => {
            changeValue(e.target.value);
          }}
          value={value}
        />
      </div>
    </div>
  );
};
